import {
  Component,
  EventEmitter,
  OnInit,
  ViewChild,
  Input,
  ViewChildren,
  QueryList,
  Output,
  HostListener
} from '@angular/core';
import { Router } from '@angular/router';
import { SelectItem } from 'primeng/api';
import { MultiSelect } from 'primeng/multiselect';
import { Table } from 'primeng/table';
import { EngagementEditInput } from '../../../models/engagement-edit-input.model';
import { EngagementPreviewInput } from '../../../models/engagement-preview-input.model';
import { PartnerInput } from '../../../models/partner-input.model';
import { TaskOwner } from '../../../models/task-owner.model';
import { PreviewDocumentTypes } from '../../../models/update-customer-ack-document.model';
import { AppConstants } from '../../common/app-constants';
import { EditComponent } from '../../home/edit/edit.component';
import { LocalStorageService } from '../../services/local-storage-service';
import { OsmosisEditService } from '../../services/osmosis-edit.service';
import { CommonSharedModule } from '../../common/shared.module';
import { EngagementPreviewComponent } from '../../preview/engagement-preview/engagement-preview.component';

@Component({
  selector: 'app-shared-engagement-table',
  templateUrl: './engagement-table.component.html',
  styleUrls: ['./engagement-table.component.scss'],
  standalone: true,
  imports: [EditComponent, EngagementPreviewComponent, CommonSharedModule]
})
export class SharedEngagementTableComponent implements OnInit {
  scrollableCols = new Array<any>();
  globalFilterCols = new Array<any>();
  loadingIcon = 'fa-circle-o-notch';
  pageLinksPerPage!: number;
  dataViewRecsPerPage!: number;
  tblPageNumber!: number;
  totalRecords!: number;
  loadEditComponent = false;
  editNav = false;
  requestDetailId!: number;
  engagementIdPassToChild!: number;
  engagementEditInput!: EngagementEditInput;
  showFullscreen = false;
  canShowPreviewModel!: boolean;
  excelLoading = false;
  taskOwnerDrpdwn!: TaskOwner[];
  ftaskOwnerDrpdwn: SelectItem[] = [];

  @ViewChild('dt', { static: false }) dt!: Table;
  @Input() engagementList!: PartnerInput[];
  @Input() isPoeDoc!: boolean;
  @Input() isPoeInvoice!: boolean;
  @Input() loading!: boolean;
  @Input() prevDocumentType!: string;
  @ViewChildren('tak') components!: QueryList<MultiSelect>;
  @ViewChild('editNavChild', { static: false }) editNavChild!: EditComponent;

  engagementPreviewInput!: EngagementPreviewInput;
  @Output() refreshList = new EventEmitter();
  sortableColumnForUploadedDate!: string;

  constructor(
    public localStorage: LocalStorageService,
    private osmEdit: OsmosisEditService,
    private router: Router
  ) {}

  @HostListener('window:resize') onresize(): void {
    requestAnimationFrame(() => {
      if (document) {
        const editEngagement = document
          .querySelector('#engagementEdit')
          ?.querySelector<HTMLElement>('[role="dialog"]');

        if (editEngagement) {
          editEngagement.style.width = '90%';
          editEngagement.style.height = '85%';
        }
      }
    });
  }

  ngOnInit() {
    this.pageLinksPerPage = AppConstants.dataListPagerLinks;
    this.dataViewRecsPerPage = AppConstants.dataListRecsPerPage;
    this.loadEditComponent = false;
    this.editNav = false;
    this.showFullscreen = this.localStorage.getFullscreenMode();

    this.engagementEditInput = {
      showFullScreen: this.showFullscreen
    } as any;

    if (
      this.prevDocumentType === PreviewDocumentTypes.customerAcknowledgement
    ) {
      this.sortableColumnForUploadedDate = 'acknowledgementDate';
    } else if (this.prevDocumentType === PreviewDocumentTypes.poeinvoice) {
      this.sortableColumnForUploadedDate = 'invoiceUploadedDate';
    } else if (this.prevDocumentType === PreviewDocumentTypes.poedocument) {
      this.sortableColumnForUploadedDate = 'poeUploadedDate';
    } else if (this.prevDocumentType === PreviewDocumentTypes.customerSurvey) {
      this.sortableColumnForUploadedDate = 'customerSurveyDate';
    }
    this.scrollableCols = [
      { field: 'engagementKey', header: 'Engagement Key' },
      { field: 'taskOwner', header: 'Task Owner' },
      { field: 'fiscalYear', header: 'Fiscal Year' },
      { field: 'engagementSubType', header: 'Engagement Sub Type' },
      { field: 'partnerInputCustomerCountry', header: 'Customer Country' },
      { field: 'partnerInputParnterName', header: 'Partner Org' },
      { field: 'partnerInputCustomerName', header: 'Customer Org' },
      { field: 'l1InternalStatus', header: 'L1Internal status' },
      { field: 'status', header: 'L2Internal status' }
    ];

    this.globalFilterCols = [
      'engagementKey',
      'taskOwner',
      'pmoNextSteps',
      'l1InternalStatus',
      'poeStatus',
      'opsStatus',
      'requestID',
      'requestDate',
      'engagementType',
      'engagementSubType',
      'partnerInputPartnerName',
      'partnerInputMPNId',
      'partnerInputSupplierId',
      'requestorFullName',
      'requestorEmail',
      'partnerInputCustomerName',
      'partnerInputCustomerCountry',
      'partnerInputCustomerTPId',
      'partnerInputCustomerTenantId',
      'partnerInputCustomerDomainName',
      'partnerInputComments'
    ];

    this.scrollableCols.push({
      field: this.sortableColumnForUploadedDate,
      header: 'Uploaded Date'
    });
    this.globalFilterCols.push(this.sortableColumnForUploadedDate);
    this.getTaskOwnerList();
  }

  pageChange(e) {
    this.tblPageNumber = e.first;
  }

  get showPreview(): boolean {
    if (this.prevDocumentType !== PreviewDocumentTypes.customerSurvey) {
      return true;
    } else {
      return false;
    }
  }

  getUploadedDate(rawData): Date {
    switch (this.prevDocumentType) {
      case PreviewDocumentTypes.customerAcknowledgement: {
        return rawData.acknowledgementDate;
      }
      case PreviewDocumentTypes.poedocument: {
        return rawData.poeUploadedDate;
      }
      case PreviewDocumentTypes.poeinvoice: {
        return rawData.invoiceUploadedDate;
      }
      case PreviewDocumentTypes.customerSurvey: {
        return rawData.customerSurveyDate;
      }
    }
    return new Date();
  }

  get currentPageInfo(): string {
    if (this.engagementList != null && this.totalRecords == undefined) {
      this.totalRecords = this.engagementList.length;
    }
    if (this.totalRecords === 0) {
      return 'No Record Found';
    } else if (
      this.tblPageNumber + this.dataViewRecsPerPage >
      this.totalRecords
    ) {
      return (
        'Showing ' +
        (this.tblPageNumber + 1) +
        ' - ' +
        this.totalRecords +
        ' of ' +
        this.totalRecords +
        ' Records'
      );
    } else if (
      this.tblPageNumber + this.dataViewRecsPerPage <=
      this.totalRecords
    ) {
      return (
        'Showing ' +
        (this.tblPageNumber + 1) +
        ' - ' +
        (this.tblPageNumber + this.dataViewRecsPerPage) +
        ' of ' +
        this.totalRecords +
        ' Records'
      );
    } else if (
      this.totalRecords > 0 &&
      this.totalRecords > this.dataViewRecsPerPage
    ) {
      return (
        'Showing 1 - ' +
        1 * this.dataViewRecsPerPage +
        ' of ' +
        this.totalRecords +
        ' Records'
      );
    } else if (
      this.totalRecords > 0 &&
      this.totalRecords <= this.dataViewRecsPerPage
    ) {
      return (
        'Showing 1 - ' +
        this.totalRecords +
        ' of ' +
        this.totalRecords +
        ' Records'
      );
    }
    return '';
  }

  applyFilter(event) {
    this.totalRecords = event.filteredValue.length;
    this.pageChange({ first: 0 });
  }

  reset() {
    this.components['_results'].forEach(ds => {
      ds.value = null;
    });

    if (this.dt) {
      this.dt.filter('', 'taskOwner', 'in');
      this.dt.filter('', 'l1InternalStatus', 'in');
      this.dt.filter('', 'engagementType', 'in');
      this.dt.reset();
      this.dt.clearFilterValues();
    }

    this.refreshList.emit(true);
  }

  onCloseEditModal() {
    this.loadEditComponent = false;
    this.editNav = false;
    this.refreshList.emit(true);
  }

  editRequestDetails(id: number) {
    this.loadEditComponent = true;
    this.editNav = true;
    this.requestDetailId = id;
    this.engagementIdPassToChild = id;
    this.engagementEditInput.engagementId = id;

    if (this.editNavChild) {
      this.editNavChild.fillEditValues(id);
    }
  }

  previewFile(engementId) {
    this.engagementPreviewInput = {
      engagementId: 0,
      previewFileIndex: 0,
      isPoePreview: false,
      isCustomerAckApproval: false,
      documentType: '',
      engagementIdList: [],
      customerSurveyResponse: [],
      isHistoryDocument: false,
      documentTypeId: 0
    };

    this.engagementPreviewInput.engagementId = engementId;
    if (this.prevDocumentType === PreviewDocumentTypes.customerSurvey) {
      this.engagementPreviewInput.documentType =
        PreviewDocumentTypes.customerSurvey;
    } else {
      this.engagementPreviewInput.previewFileIndex = 0;
      if (this.isPoeDoc) {
        this.engagementPreviewInput.isCustomerAckApproval = false;
        this.engagementPreviewInput.isPoePreview = true;
        this.engagementPreviewInput.documentType =
          PreviewDocumentTypes.poedocument;
      } else if (this.isPoeInvoice) {
        this.engagementPreviewInput.isCustomerAckApproval = false;
        this.engagementPreviewInput.isPoePreview = true;
        this.engagementPreviewInput.documentType =
          PreviewDocumentTypes.poeinvoice;
      } else {
        this.engagementPreviewInput.isCustomerAckApproval = true;
        this.engagementPreviewInput.isPoePreview = false;
      }
    }
    this.engagementPreviewInput.engagementIdList = this.engagementList.map(
      engagement => engagement.engagementKey as number
    );
    this.canShowPreviewModel = true;
  }

  closePreview() {
    this.canShowPreviewModel = false;
    this.engagementPreviewInput = {} as EngagementPreviewInput;
  }

  onShowFullScreenChanged(showFullscreenValue: boolean) {
    this.showFullscreen = showFullscreenValue;
    this.localStorage.setFullscreenMode(this.showFullscreen);
  }

  refresh() {
    this.refreshList.emit(true);
  }

  export() {
    this.router.navigate(['/download-csv']);
  }

  getTaskOwnerList() {
    this.osmEdit.getTaskOwnerDropDown().subscribe(PTList => {
      this.taskOwnerDrpdwn = PTList;
      for (const item of this.taskOwnerDrpdwn) {
        const ftaskOwnerDrpdwn: SelectItem = {
          label: item.taskOwner,
          value: item.taskOwner
        };
        this.ftaskOwnerDrpdwn.push(ftaskOwnerDrpdwn);
      }
    });
  }
}
